import { createStore } from 'vuex'
import auth from './auth'
import info from './info'
import project from '@/service/store/project'
import classes from '@/service/store/classes'
import config from "@/build/build";
import createMultiTabState from 'vuex-multi-tab-state'
import { typeFormat, formatSqlDate, formatSqlDateTime, dateFilter, crypted, decrypted, lowerCaseLetter, upperCaseLetter, formatString } from '../utils';


export const loadStimulsoftLicense = (retries = 5, delay = 200) => {
  if (window.Stimulsoft?.Base?.StiLicense) {
    window.Stimulsoft.Base.StiLicense.loadFromFile('license.key');
    return;
  }
  if (retries > 0) {
    setTimeout(() => loadStimulsoftLicense(retries - 1, delay), delay);
  }
};

export default createStore({
  state: {
    error: null,
    source: null,
    direction: 'EXTERNAL',
    protocol: null,
    hostname: null,
    server: {},
    serverTemplate: {}
  },
  actions: {
    setDirection: ({ commit }, val) => {
      commit('SET_DIRECTION', val)
    },
    setProtocol: ({ commit }, val) => {
      commit('SET_PROTOCOL', val)
    },
    setHostname: ({ commit }, val) => {
      commit('SET_HOSTNAME', val)
    },
  },
  mutations: {
    SET_ERROR(state, { er, source }) {
      console.error(er, source);
      state.error = er;
      state.source = source;
    },
    CLEAR_ERROR(state) {
      state.error = null;
      state.source = null;
    },
    SET_DIRECTION(state, direction) {
      state.server = window.SERVERS[process.env.VUE_APP_SERVER_NAME]?.[direction];
      state.serverTemplate = window.SERVERS['COMMON'][direction];
      state.direction = direction;
    },
    SET_PROTOCOL(state, protocol) {
      state.protocol = protocol;
    },
    SET_HOSTNAME(state, hostname) {
      state.hostname = hostname;
    },
  },
  plugins: [createMultiTabState({
    statesPaths: [
      'info.info',
      'info.user',
      'info.visibleColumns',
      'info.passwordExpirationDate',
      'project.dept',
      'project.monitoringUpdate',
      'project.propertyUpdate',
      'project.hideRepeatWell',
      'project.structMode',
      'project.eventUpdate',
      'project.enableEventSound',
      'project.enableEventFacilitySound',
      'project.propertyColor',
      'project.speechRate',
      'project.speechPitch',
    ]
  })],
  getters: {
    error: s => s.error,
    source: s => s.source,
    const: () => (key) => window.VOCABULARY[key] ?? key,
    constStrict: () => (key) => window.VOCABULARY[key],
    config: () => (key) => config[key],
    server: (s) => (key) => s.server?.[key] ? s.server[key] : formatString(s.serverTemplate[key], `${s.protocol}//${s.hostname}`),
    connectionPath: (s) => s.server?.['CONNECTION_PATH'] ?
      s.server['CONNECTION_PATH'] : formatString(s.serverTemplate['CONNECTION_PATH'], `${s.hostname},${s.direction === 'LOCAL' ? '1433' : '2433'}`, '{0}', '{1}'),
    direction: s => s.direction,
    typeFormat: () => (value, type) => typeFormat(value, type),
    formatSqlDate: () => (date, gmt) => formatSqlDate(date, gmt),
    formatSqlDateTime: () => (date, gmt) => formatSqlDateTime(date, gmt),
    dateFilter: () => (value, filter) => dateFilter(value, filter),
    crypted: () => (value) => crypted(value),
    decrypted: () => (array) => decrypted(array),
    lowerCaseLetter: () => (value) => lowerCaseLetter(value),
    upperCaseLetter: () => (value) => upperCaseLetter(value)

  },
  modules: {
    auth,
    info,
    project,
    classes
  }
})